/**
 * Warehouse schema holding the curated `fact_*` / `dim_*` tables.
 *
 * The Redshift pg client sets `search_path` to `silver` (see
 * `create-redshift-pg-client.ts`), so anything in `gold` must be schema-qualified.
 */
const GOLD_SCHEMA = 'gold';

/** Daily snapshot of lab panel status per patient, one row per patient (PLTFM-1238). */
const LAB_STATUS_SUMMARY_TABLE = `${GOLD_SCHEMA}.fact_patient_lab_status_summary`;

/**
 * Lab panels tracked by `fact_patient_lab_status_summary`, in the display order used
 * by the source report. `column` is the table's column prefix; `label` is the value
 * pushed to Iterable.
 */
const LAB_PANELS = Object.freeze([
  { column: 'tsh', label: 'TSH' },
  { column: 'lipid', label: 'Lipid' },
  { column: 'a1c', label: 'A1C' },
  { column: 'cmp', label: 'CMP' },
  { column: 'cbc', label: 'CBC' },
]);

/** Per-panel status values in `fact_patient_lab_status_summary`. */
const LAB_PANEL_STATUSES = Object.freeze({
  /** Resulted within the trailing 12 months. */
  COMPLETED: 'COMPLETED',
  /** No result within 12 months and no open order. */
  MISSING: 'MISSING',
  /** No result within 12 months, but an order is open. */
  ORDERED: 'ORDERED',
});

/** `overall_status` value meaning every tracked panel is complete. */
const LAB_OVERALL_STATUS_ALL_COMPLETED = 'ALL_COMPLETED';

/** Human-readable `labStatus` values, preserved from the original ad-hoc report. */
const LAB_STATUS_LABELS = Object.freeze({
  WITHIN_12_MONTHS: 'Within 12 Months',
  OUTSIDE_12_MONTHS: 'Outside 12 Months',
});

/** Daily snapshot of cross-channel patient activity, one row per patient (PLTFM-1276). */
const PATIENT_ENGAGEMENT_SNAPSHOT_TABLE = `${GOLD_SCHEMA}.fact_patient_engagement_snapshot`;

module.exports = {
  ATHENA_RD_GROUP_VISIT_FIELD: 'RD Group Visit',
  ATHENA_REFUSING_RD_FIELD: 'Refusing RD Appts',
  GOLD_SCHEMA,
  LAB_STATUS_SUMMARY_TABLE,
  LAB_PANELS,
  LAB_PANEL_STATUSES,
  LAB_OVERALL_STATUS_ALL_COMPLETED,
  LAB_STATUS_LABELS,
  PATIENT_ENGAGEMENT_SNAPSHOT_TABLE,
};
